import { render, staticRenderFns } from "./link-box.vue?vue&type=template&id=d9703456&scoped=true"
import script from "./link-box.vue?vue&type=script&lang=js"
export * from "./link-box.vue?vue&type=script&lang=js"
import style0 from "./link-box.vue?vue&type=style&index=0&id=d9703456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9703456",
  null
  
)

export default component.exports